import React from 'react';
import { GlobalStyles } from '@mui/material';

const INK = '#000000';
const HINT = '#9A9A9A';

const SUISSE = "'Suisse Intl', 'Inter', sans-serif";

const styles = {
  body: { letterSpacing: 0 },
  '.MuiFormHelperText-root': { letterSpacing: 0 },
  '.MuiTypography-h1, .MuiTypography-h2, .MuiTypography-h3, .MuiTypography-h4, .MuiTypography-h5, .MuiTypography-h6':
    {
      fontFamily: `${SUISSE} !important`,
      fontWeight: '450 !important',
    },
  '.MuiTypography-h3': { letterSpacing: '-0.5px !important' },
  '.MuiAutocomplete-popupIndicator .MuiSvgIcon-root': {
    fontSize: '20px',
    color: '#808080',
  },
  '.MuiAutocomplete-popupIndicator:hover': { backgroundColor: 'transparent' },
  '.MuiFormHelperText-root:not(.Mui-error)': { color: `${HINT} !important` },
  'label.MuiFormLabel-root.MuiFormLabel-root.MuiInputLabel-root.MuiInputLabel-root.MuiInputLabel-root:not(.Mui-error)':
    {
      color: `${INK} !important`,
    },
  '.MuiChip-root:not(.draft-chip)': {
    backgroundColor: '#EFEFEF !important',
    color: `${INK} !important`,
    borderRadius: '29px !important',
  },
  '.MuiChip-root:not(.draft-chip) .MuiChip-deleteIcon': {
    color: `${INK} !important`,
  },
};

const FieldStyles: React.FC = () => <GlobalStyles styles={styles} />;

export default FieldStyles;
